//rafce
import React, {useState,useEffect,useRef,useMemo} from "react";
import axios from "axios";
import jwt_decode from "jwt-decode";
import { Link, useNavigate } from "react-router-dom";
import Dialog from "./Dialog";
import MaterialReactTable from 'material-react-table';
import { ExcelExport,ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { process as processex} from "@progress/kendo-data-query";
import { FcPrint } from "react-icons/fc";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { toast } from 'react-toastify';
import RiseLoader from "react-spinners/RiseLoader";
import SideBar from "./sidebar/Sidebar";
import { capitalize } from "@mui/material";


//DONT DELETE!!
// Sourch Code reference from : https://www.telerik.com/kendo-react-ui/components/excelexport/
//                    https://www.npmjs.com/package/material-react-table

const styleTittle = {

  fontSize: 20,
  color: "#4a54f1",
  textAlign: "center",
  paddingBottom: "20px",
  paddingTop: "5px",

}

const stylespinner = {
  position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"
}

const Barang = () => {

  const month = ["January","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
  const [loading, setLoading] = useState(true);



    const [barang,setBarang] = useState([]);
    // const [username, setUsername] = useState("");
    // const [email, setEmail] = useState("");
    const [cabang, setCabang] = useState("");
    const [role, setRole] = useState("");
    const [token, setToken] = useState("");
    const [expire, setExpire] = useState("");
    const navigate = useNavigate();
    const _exporter = React.createRef();

useEffect(() => {
    // setLoading(true)
    // setTimeout(()=> {
    //   setLoading(false)
    // },2500);
    refreshToken();
    if (cabang && role) {
        getBarang();
      }
},[cabang, role]);

    const axiosJWT = axios.create();
    axiosJWT.interceptors.request.use(async(config) => {
      const curretDate = new Date();
      if(expire * 1000 < curretDate.getTime()){
          const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
          config.headers.Authorization = `Bearer ${response.data.accessToken}`;
          setToken(response.data.accessToken);
          const decoded = jwt_decode(response.data.accessToken);
          setCabang(decoded.cabang);
          setRole(decoded.role);
          setExpire(decoded.exp);
      }
      return config;
    }, (error) => {
      return Promise.reject(error);
    });

  const refreshToken = async() => {
  try {
        const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setCabang(decoded.cabang);
        setRole(decoded.role);
        setExpire(decoded.exp);

  } catch (error) {
      if(error.response){
        navigate("/login");
      }
  }
}


const getBarang = async () => {
    // setLoading(true)
    refreshToken();
    const response = await axiosJWT.get(`${process.env.REACT_APP_MASTER_URL}/barang`,{
        params: {
                    cabang: cabang,
                    role: role
                },
        headers:{
            Authorization:`Bearer ${token}`
        }
    });
    
    setBarang(response.data[0]);
    setLoading(false);
}

const [dialog, setDialog] = useState({
    message:"",
    isLoading:false,
    namaBarang:""
});

const handleDialog = (message, isLoading, namaBarang)=> {
    setDialog({
        message,
        isLoading,
        namaBarang
    });
};

const idBarangRef = useRef();

const handleDelete = (idBarang,namaBarang)=> {
    handleDialog("Yakin Ingin Hapus?",true,namaBarang);
    idBarangRef.current = idBarang;
    
};

const areUSureDelete = (choose) => {
    if (choose) {
      deletebarang(idBarangRef.current);   
      handleDialog("", false);
    } else {
      handleDialog("", false);
    }
  };

const deletebarang = async (idBarang) =>{
    try {
        await axios.delete(`${process.env.REACT_APP_MASTER_URL}/barang/${idBarang}`);
        getBarang();
        toast.info("Hapus Barang Berhasil");
    } catch (error) {
        toast.error("Hapus Gagal, Kesalahan Server");
        console.log(error);
        
    }
}
  
  //Table
  const columns = useMemo(
    () => [
   
      {
        accessorKey: "kodeBarang", //simple recommended way to define a column
        header: "Kode Barang",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>, //optional custom cell render
        size: 10
      },
      {
        accessorKey: "cabang", //simple recommended way to define a column
        header: "Cabang",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "namaBarang", //simple recommended way to define a column
        header: "Nama Barang",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "jenisKategori", //simple recommended way to define a column
        header: "Kategori",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      // {
      //   accessorKey: "stok", //simple recommended way to define a column
      //   header: "Stok",
      //   muiTableHeadCellProps: { sx: { color: "blue" } }, //custom props
      //   Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
      //   //optional custom cell render
      // },
      {
        accessorKey: "stok", //simple recommended way to define a column (toString(role) === toString(compare) ? show : null)
        header: "Stok",
        muiTableHeadCellProps: { sx: { color: "green" } },
         //custom props
        Cell: ( props ) => (  props.row.original.stok<=props.row.original.qtyMin || props.row.original.stok>=props.row.original.qtyMax  ? 
                              <a style={{color:'red'}}>{props.row.original.stok}
                              </a>:
                              <a style={{color:'blue'}}>{props.row.original.stok}
                              </a>

        )
                            
      },
      {
        accessorKey: "qtyMax", //simple recommended way to define a column
        header: "Stok Maksimal",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorKey: "qtyMin", //simple recommended way to define a column
        header: "Stok Minimal",
        muiTableHeadCellProps: { sx: { color: "green" } }, //custom props
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong> //optional custom cell render
      },
      {
        accessorFn: (row) => row.ket, //alternate way
        id: "ket", //id required if you use accessorFn instead of accessorKey
        header: "Keterangan",
        Header: <i style={{ color: "green" }}>Ket.</i> //optional custom markup
      },
      {
        accessorKey: "idBarang", //simple recommended way to define a column (toString(role) === toString(compare) ? show : null)
        header: "Aksi",
        muiTableHeadCellProps: { sx: { color: "red" } },
         //custom props
        Cell: ( props ) => (  <a><Link to={`edit/${props.row.original.idBarang}`} className="button is-small is-link">Edit</Link>
                                    <button
                                        onClick={() => handleDelete(props.row.original.idBarang,props.row.original.namaBarang )}
                                        className="button is-small is-danger">
                                        Delete
                                    </button>
                                </a>
                            ),
      },
    ],
    []
  ); 

  //Data Excel
  const data = processex(barang,{}).data;
    const excelExport = () => {
      if (_exporter.current) {
        _exporter.current.save();
      }
    };

    const columnspdf = [
      { title: "Kode Barang", field: "kodeBarang", },
      { title: "Nama Barang", field: "namaBarang", },
      { title: "Kategori", field: "jenisKategori", },
      { title: "Stok", field: 'stok', type: "number" },
      { title: "Keterangan", field: 'keterangan', }]

    // const downloadPdf = () => {
    //   const doc = new jsPDF()
    //   // const image = new image()
    //   // image.src='http://localhost:5001/assets/logonusamba.png'
    //   // doc.addImage(image, 'png', 10, 78, 12, 15)
    //   doc.setFontSize(14)
    //   doc.text("Laporan Stok Barang BPR Nusamba Brondong", 100, 10,'center')
    //   doc.setFontSize(10)
    //   doc.text(`Tanggal: ${new Date().getDate()} ${month[new Date().getMonth()]} ${new Date().getFullYear()}`,18, 27, )
    //   doc.autoTable({
    //     theme: "grid",
    //     columns: columnspdf.map(col => ({ ...col, dataKey: col.field })),
    //     margin: { top: 30},
    //     body: barang
    //   })
    //   doc.save(`Laporan Stok Barang Nusamba Brondong ${new Date().getDate()}-${month[new Date().getMonth()]}-${new Date().getFullYear()}.pdf`)
    // }
    const downloadPdf = () => {
      const doc = new jsPDF();
      const logoImg = new Image();
      logoImg.src = `${process.env.REACT_APP_MASTER_URL}/assets/logonusamba.png`;
    
      logoImg.onload = function () {
        // Menambahkan gambar ke PDF
        doc.addImage(logoImg, 'PNG', 19, 2, 30, 12);
    
        doc.setFontSize(14);
        doc.text("Laporan Stok Barang", 102, 10, 'center');
        doc.text(`BPR Bank Nusamba JATIM Cab.${cabang}`, 102, 15, 'center');
        doc.setFontSize(10);
        doc.text(`Tanggal: ${new Date().getDate()} ${month[new Date().getMonth()]} ${new Date().getFullYear()}`, 18, 27);
        doc.autoTable({
          theme: "grid",
          columns: columnspdf.map(col => ({ ...col, dataKey: col.field })),
          margin: { top: 30 },
          body: barang
        });
    
        doc.save(`Laporan Stok Barang Nusamba Jatim Cab.${cabang} ${new Date().getDate()}-${month[new Date().getMonth()]}-${new Date().getFullYear()}.pdf`);
      };
    };
    
   
  return (
  <div>
        {loading ?
          <div style={stylespinner}>
            <RiseLoader
              color={'#301E67'}
              loading={loading}
              size={20}
              hidden={100}
              textAlign='centered'
              aria-label="Loading Spinner"
              data-testid="loader"
            />
           </div> 
            :
    <SideBar>
        <div className="columnms mt-5 is centered">
        <img src={`${process.env.REACT_APP_MASTER_URL}/assets/logonusamba.png`}  alt="Not Found" width={300} height={300}></img>
              <label className='label' style={styleTittle}><center>INVENTARIS BARANG <p/>BPR NUSAMBA JATIM CAB.{cabang.toUpperCase()}</center></label>
              <Link to={'tambahbarang'} className="button is-link">Tambah Baru</Link>
              <button onClick={downloadPdf} className="button is-link ml-5">Export PDF</button>
              {role==='superAdmin' ? <button className="button is-danger ml-5" onClick={excelExport}>
                      Export to Excel
              </button> : null }
  
              <ExcelExport
                          data={data}
                          collapsible={true}
                          fileName={`Laporan Stok Barang ${new Date().getDay()}-${month[new Date().getMonth()]}-${new Date().getFullYear()}.xlsx`}
                          ref={_exporter}>
                          <ExcelExportColumn field="kodeBarang" title="Kode Barang" />
                          <ExcelExportColumn field="namaBarang" title="Nama Nasabah" width={200} />
                          <ExcelExportColumn field="jenisKategori" title="Kategori" />
                          <ExcelExportColumn field="qtyMax" title="qtyMax"/>
                          <ExcelExportColumn field="qtyMin" title="qtyMin" />
                          <ExcelExportColumn field="stok" title="stok" />
                          <ExcelExportColumn field="ket" title="Keterangan" />
              </ExcelExport>
                 {role==='superAdmin' ? <MaterialReactTable 
                              enableRowNumbers
                              rowNumberMode="original"
                              initialState={{ columnVisibility: { idBarang: true } } }
                              columns={columns} data={barang} 
                              // enableStickyHeader
                              enableStickyFooter
                              actions={[
                                {
                                  icon: () => <FcPrint />,// you can pass icon too
                                  tooltip: "Export to Pdf",
                                  onClick: () => downloadPdf(),
                                  isFreeAction: true
                                }
                              ]}
                              defaultColumn={{
                                minSize: 10, //allow columns to get smaller than default
                                maxSize: 20, //allow columns to get larger than default
                                size: 120, //make columns wider by default
                              }}
                      /> : <MaterialReactTable 
                              
                              rowNumberMode="original"
                              initialState={{ columnVisibility: { idBarang: false } } }
                              columns={columns} data={barang} 
                              enableStickyHeader
                              enableStickyFooter
                          
                              defaultColumn={{
                                minSize: 10, //allow columns to get smaller than default
                                maxSize: 60, //allow columns to get larger than default
                                size: 100, //make columns wider by default
                              }}
                      
                    />
                  }
                
              {dialog.isLoading && (
                  <Dialog
                  //Update
                  nameProduct={dialog.namaBarang}
                  onDialog={areUSureDelete}
                  message={dialog.message}
                  />
                  )}
      </div>   
      
    </SideBar> 
      }
  </div>
  )
}

export default Barang